import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  max-width: 450px;
  background: #fafafa;
  padding: 25px;
  border-radius: 4px;

  display: flex;
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  margin-right: 16px;
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  strong {
    font-size: 28px;
    color: #01579b;
  }
`;

export const Content = styled.main`
  font-size: 16px;
  padding-left: 16px;
  border-left: 1px solid #c7c7c7;

  span {
    margin-top: 8px;
    color: #666;
  }

  div {
    margin-top: 24px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;

    section {
      width: 100%;
      display: flex;

      & + section {
        margin-top: 8px;
      }
    }

    button {
      padding: 8px;
      border-radius: 4px;
      color: #fff;
      transition: background 0.2s;
      flex: 1;

      & + button {
        margin-left: 16px;
      }
    }

    section:nth-child(1) {
      button:nth-child(1) {
        background: #00c853;
        padding-left: 20px;
        padding-right: 20px;

        &:hover {
          background: ${darken(0.05, '#00c853')};
        }
      }

      button:nth-child(2) {
        background: #ee4256;
        padding-left: 20px;
        padding-right: 20px;

        &:hover {
          background: ${darken(0.05, '#ee4256')};
        }
      }
    }

    section:nth-child(2) {
      width: 100%;
      display: flex;

      button {
        background: #01579b;

        &:hover {
          background: ${darken(0.05, '#01579B')};
        }
      }
    }
  }
`;
